const initFooter = () => {
  const $element = jQuery('.js-address-element');
  const $mobileTarget = jQuery('.js-address-location-mobile');
  const $desktopTarget = jQuery('.js-address-location-desktop');

  if (!$element.length || !$mobileTarget.length || !$desktopTarget.length) {
    console.warn("One or more selectors not found");
    return;
  }

  function moveElement() {
    if (jQuery(window).width() <= '768px') {
      if (!$mobileTarget.has($element).length) {
        $element.appendTo($mobileTarget);
      }
    } else {
      if (!$desktopTarget.has($element).length) {
        $element.appendTo($desktopTarget);
      }
    }
  }

  // Run once on load
  moveElement();

  // Listen for resize events
  jQuery(window).on('resize', function () {
    moveElement();
  });
}

export {initFooter}